import { request } from "../helper/axios_helper";

// Master Suite scheduling API. The control password is sent in the request body
// (never in the URL) and is never returned by the backend.

export const createSchedule = (data) =>
  request("POST", "/api/auth/schedule/create", data);

export const getSchedules = () => request("GET", "/api/auth/schedule/list");

export const updateSchedule = (id, data) =>
  request("PUT", `/api/auth/schedule/update/${id}`, data);

export const toggleSchedule = (id, enabled, password) =>
  request("PUT", `/api/auth/schedule/toggle/${id}`, { enabled, password });

export const deleteSchedule = (id, password) =>
  request("DELETE", `/api/auth/schedule/delete/${id}`, { password });

export const resetSchedulePassword = (id, newPassword) =>
  request("POST", `/api/auth/schedule/reset-password/${id}`, { newPassword });

export const getScheduleIsAdmin = () =>
  request("GET", "/api/auth/schedule/is-admin");
